// Shared button handler logic for both App.js and ChatScreen.js

export const handleQuickButton = async (label, setMessages, setIsLoading) => {
  if (label === 'Contact') {
    setMessages((msgs) => [...msgs, { type: 'contact_card' }]);
  } else if (label === 'Skills') {
    setMessages((msgs) => [...msgs, { type: 'skills_card' }]);
  } else if (label === 'Experience') {
    setMessages((msgs) => [...msgs, { type: 'work_card' }]);
  } else if (label === 'Projects') {
    setMessages((msgs) => [...msgs, { type: 'projects_card' }]);
  } else if (label === 'Me') {
    const prompt = "Introduce Vibhor professionally in detail in presentable response format.";
    setIsLoading(true); 
    // send prompt to backend, get response and append only bot message
    try {
      const res = await fetch('https://ai-portfolio-backend-w6r0.onrender.com/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: prompt }),
      });
      const data = await res.json();
      setMessages((msgs) => [...msgs, { type: 'bot', text: data.response }]);
    } catch {
      setMessages((msgs) => [...msgs, { type: 'bot', text: 'Error: Server unreachable.' }]);
    }
    setIsLoading(false);
  }
};

export const quickButtons = [
  { label: 'Me', icon: '👤' },
  { label: 'Projects', icon: '👜' },
  { label: 'Skills', icon: '📚' },
  { label: 'Experience', icon: '💼' },
  { label: 'Contact', icon: '🔑' },
];
